// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/customization_change_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/customization_change_response.proto.
 */
export const file_responses_v1_customization_change_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjByZXNwb25zZXMvdjEvY3VzdG9taXphdGlvbl9jaGFuZ2VfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSItChtDdXN0b21pemF0aW9uQ2hhbmdlUmVzcG9uc2USDgoGYWN0aXZlGAEgASgIQosBChBjb20ucmVzcG9uc2VzLnYxQiBDdXN0b21pemF0aW9uQ2hhbmdlUmVzcG9uc2VQcm90b1ABWgQuL3BiogIDUlhYqgIMUmVzcG9uc2VzLlYxygIMUmVzcG9uc2VzXFYx4gIYUmVzcG9uc2VzXFYxXEdQQk1ldGFkYXRh6gINUmVzcG9uc2VzOjpWMWIGcHJvdG8z'
    );

/**
 * @generated from message responses.v1.CustomizationChangeResponse
 */
export type CustomizationChangeResponse = Message<'responses.v1.CustomizationChangeResponse'> & {
    /**
     * @generated from field: bool active = 1;
     */
    active: boolean;
};

/**
 * Describes the message responses.v1.CustomizationChangeResponse.
 * Use `create(CustomizationChangeResponseSchema)` to create a new message.
 */
export const CustomizationChangeResponseSchema: GenMessage<CustomizationChangeResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_customization_change_response, 0);
